<template>
    <div>
        <el-select v-model="selected" :placeholder="$t('Seçin')" size="small" filterable style="width: 100%"
            :disabled="readonly || !regionId" @change="handleChange">
            <el-option v-for="item in data" :key="item.commId" :label="getUserLabel(item)" :value="item.commId" />
        </el-select>
    </div>
</template>

<script>
import { GetAvailableAccidentComms } from "../../services/cls";
import { usersbyrole } from "../../services/sales";

export default {
    props: {
        value: [Number, String],
        regionId: { type: [Number, null], default: null },
        readonly: { type: Boolean, default: false },
    },
    data() {
        return {
            selected: this.value,
            data: [],
            users: [],
        };
    },
    watch: {
        value(v) {
            this.selected = v;
        },
        regionId: {
            immediate: true,
            handler(id) {
                if (id) this.loadData(id);
                else {
                    this.data = [];
                    this.selected = null;
                    this.$emit("input", null);
                    this.$emit("comm", "");
                }
            },
        },
    },
    methods: {
        async loadData(regionId) {
            try {
                const [commsRes, usersRes] = await Promise.all([
                    GetAvailableAccidentComms({ RegionId: regionId, CommandUserId: this.$store.state.user.id }),
                    usersbyrole(4)
                ]);

                this.data = commsRes?.data?.data || [];
                this.users = usersRes?.data || [];

                if (this.data.length === 1) {
                    const singleComm = this.data[0];
                    this.selected = singleComm.commId;
                    this.$emit("input", singleComm.commId);
                    const name = this.getUserName(singleComm.commId);
                    this.$emit("comm", name);
                }
                
            } catch {
                this.$message.error(this.$t('Xəta_baş_verdi_6'));
            }
        },
        handleChange(val) {
            this.$emit("input", val);
            const name = this.getUserName(val);
            this.$emit("comm", name);
        },
        getUserName(commId) {
            const user = this.users.find(u => u.id === commId);
            return user ? user.name : "";
        },
        getUserLabel(item) {
            const name = this.getUserName(item.commId);
            if (item.isAssistant) {
                return `${name} - Köməkçi`;
            } else if (item.timeFrom && item.timeTo) {
                const from = item.timeFrom.slice(0, 5); 
                const to = item.timeTo.slice(0, 5);
                return `${name} (${from} - ${to})`;
            } else {
                return name;
            }
        }
    },
};
</script>

<style scoped></style>